import FileExplorerBulkActions from './FileExplorerBulkActions';

export default FileExplorerBulkActions;
